<div class="fx-layout-row fx-layout-align-space-around-m fx-layout-align-center-x">
  <div class="interactions-counter fx-layout-column">
    <label style="font-size: 16px; padding-bottom: 14px;" class="centred-text">Interactions</label>
    <interactions-counter style="padding-bottom: 114px;" [total]="interactions.toString()"></interactions-counter>
  </div>
  <div class="barchart fx-layout-column">
    <label style="font-size: 16px; padding-bottom: 5px;" class="centred-text">Case Status Overview</label>
    <canvas width="300" height="200" #casesTotalsCanvas [hidden]="emptyBar" ></canvas>
    <img style="scale: 0.6;" height="200" src="assets/images/EmptyCharts/emptyBar.png" [hidden]="!emptyBar" alt="No Data" />
  </div>
  <div class="barchart fx-layout-column">
    <label style="font-size: 16px; padding-bottom: 5px;" class="centred-text">Case Categories Overview</label>
    <canvas width="300" height="200" #caseCategoriesCanvas [hidden]="emptyCaseCategoriesPie" ></canvas>
    <img style="scale: 0.8;" height="200" src="assets/images/EmptyCharts/emptyPie.png" [hidden]="!emptyCaseCategoriesPie" alt="No Data" />
  </div>
  <div class="barchart fx-layout-column">
    <label style="font-size: 16px; padding-bottom: 5px;" class="centred-text">Case Types Overview</label>
    <canvas width="350" height="200" #caseTypesCanvas [hidden]="emptyCaseTypesPie" ></canvas>
    <img style="scale: 0.8;" height="200" src="assets/images/EmptyCharts/emptyPie.png" [hidden]="!emptyCaseTypesPie" alt="No Data" />
  </div>
</div>
<div class="fx-gap-40"></div>
<div class="fx-layout-row fx-layout-align-space-around-m fx-layout-align-center-x">
  <div style="padding-top: 15px;" class="centred-text fx-flex-50">
    <label>Please note: Dashboard data is only from the last 12 months</label>
  </div>
</div>
